import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// API
import * as API  from '../../../../utils/api'

// Form Components
import LockerProfileForm from './LockerProfileForm/LockerProfileForm'
import FormContainer from '../../../../components/Global/FormContainer'

// Profile Components
import ProfileImageUploader from '../../../../components/UserPortal/Locker/Profile/ProfileImageUploader'
import ProfileBio from '../../../../components/Profile/ProfileBio'
import ProfileHeaderStats from '../../../../components/Profile/ProfileHeaderStats'

// Flash Message Component
import FlashMessage from '../../../../components/Global/FlashMessage';

class LockerProfile extends Component {
  state ={
    isLoading: true,
    flashMessage: {
      type: '',
      message: '',
    },
    displayFlashMessage: false,
    lockerProfileParticipation: null
  }

  componentWillReceiveProps(nextProps) {
    // If switching active profiles, make sure the flash message is removed
    if (this.props.activeProfile.username !== nextProps.activeProfile.username) {
      this.setFlashMessage('', '', false)
    }

    nextProps.participation && this.setState({
      lockerProfileParticipation: nextProps.participation,
      isLoading: false
    })
  }

  getSocialMediaData = () => {
    const { activeProfile } = this.props

    return [
      {
        name: 'facebook',
        url: activeProfile.facebook_username ? activeProfile.facebook_username : null,
      },
      {
        name: 'hudl',
        url: activeProfile.hudl_username ? activeProfile.hudl_username : null,
      },
      {
        name: 'twitter',
        url: activeProfile.twitter_username ? activeProfile.twitter_username : null,
      }
    ]
  }

  handleSubmit = (valuesForSubmit) => {
    const { user } = this.props
    const { lockerProfileParticipation } = this.state

    const sportPositionOptions = valuesForSubmit.primary_positions
    delete valuesForSubmit.primary_positions

    API.updateParticipation(
      user,
      lockerProfileParticipation,
      valuesForSubmit
    )
    .then(response => {
      if (response.errors) {
        this.handleErrorSubmit(response.errors[0])
      } else {
        valuesForSubmit.primary_positions = sportPositionOptions
        delete valuesForSubmit.primary_position_ids
        this.handleSuccessfulSubmit(valuesForSubmit)
      }
    })
  }

  handleSuccessfulSubmit(updates) {
    let updatedPartipation = {
      ...this.state.lockerProfileParticipation,
      ...updates
    }

    window.scrollTo(0, 0)

    this.setState(({
      lockerProfileParticipation: updatedPartipation,
    }), this.setFlashMessage('', 'Changes saved successfully', true))
  }

  handleErrorSubmit(message) {
    window.scrollTo(0, 0)
    this.setFlashMessage('error', `Error: ${message}`, true)
  }

  setFlashMessage = (type, message, display) => {
    this.setState({
      flashMessage: {
        type,
        message
      },
      displayFlashMessage: display
    })
  }

  renderFlashMessage() {
    const {
      displayFlashMessage,
      flashMessage
    } = this.state;

    return displayFlashMessage
    ? (
      <FlashMessage optionalClasses={flashMessage.type === 'error' ? 'error' : ''}>
        {flashMessage.message}
      </FlashMessage>
    ) : null
  }

  render() {
    const {
      activeProfile,
      updateParticipation
    } = this.props

    const {
      isLoading,
      lockerProfileParticipation
    } = this.state

    const { trial_active, on_trial } = this.props.activeProfile.trial_info
    const isLocked = on_trial && !trial_active

    return isLoading
    ? null
    : (
        <FormContainer optionalClassName="locker-profile" isLocked={isLocked}>
        {this.renderFlashMessage()}
        <header className="profile-header">
          <ProfileImageUploader
            imageUrl={lockerProfileParticipation.profile_image_url}
            updateParticipation={updateParticipation}
            participationID={lockerProfileParticipation.id}
            setFlashMessage={this.setFlashMessage}
          />
          <div className="profile-header-details">
            <ProfileBio
              profile={ activeProfile }
              participation={ lockerProfileParticipation }
            />
          </div>
          <ProfileHeaderStats
            profile={ activeProfile }
            participation={ lockerProfileParticipation }
          />
          <Link to="/settings/athlete-info" className="text-link">
            Edit Athlete Info and Social Media Profiles
          </Link>
        </header>
        <LockerProfileForm
          participation={lockerProfileParticipation}
          onSubmit={this.handleSubmit}
        />
      </FormContainer>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activeProfile: state.activeProfile
  }
}

export default connect(
  mapStateToProps,
  null
)(LockerProfile)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Locker/LockerScreens/LockerProfile.js